import { addToCart } from '~/js/lib/cart'; // eslint-disable-line
import { getOrdinalSuffix } from '~/js/utils/util-functions'; // eslint-disable-line

export default (node) => {
  /**
   * Data + elements
   */

  const chattersPopup = document.getElementById('chatters-popup');

  const shippingTodayNode = document.querySelector(
    '[data-component="shippingToday"]'
  );

  const moneyFormat = node
    .getAttribute('data-money-format')
    .replace('amount_with_dot_separator', 'amount');

  const priceElement = document.getElementById('price');
  const compareAtPriceElement = document.getElementById('compare-at-price');
  const suggestedRetailPriceElement = document.getElementById(
    'suggested-retail-price'
  );

  const buttonAddToCart = node.querySelector('[button-add-to-cart]');
  const popupAddToCartButton = document.querySelector(
    '[data-add-to-cart-button]'
  );
  const quantityInput = node.querySelector('[data-quantity-input]');
  const quantityAndAddToCartWrapper = node.querySelector(
    '[data-quantity-add-to-cart-wrapper]'
  );
  const quantityIncrease = node.querySelector('[data-quantity-increase]');
  const quantityDecrease = node.querySelector('[data-quantity-decrease]');

  const outOfStockButtonWrapper = node.querySelector(
    '[data-out-of-stock-button-wrapper]'
  );
  const notifyWhenInStockForm = node.querySelector(
    '[data-notify-when-in-stock-form]'
  );
  const notifyBackInStockVariantId = node.querySelector(
    '[data-notify-when-in-stock-variant-id]'
  );
  const notifyWhenInStockRegularMessage = node.querySelector(
    '[data-notify-when-in-stock-regular]'
  );
  const notifyWhenInStockSuccessMessage = node.querySelector(
    '[data-notify-when-in-stock-success]'
  );

  const preorderCallout = node.querySelector('[data-preorder-callout]');

  const observeElement = (selector, onAdded, onRemoved) => {
    let elementPresent = !!document.querySelector(selector);

    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);
      // Element was found and previously didn't exist: it was just added
      if (element && !elementPresent) {
        elementPresent = true;
        onAdded(element);
      }
      // Element no longer found but previously existed: it was just removed
      else if (!element && elementPresent) {
        elementPresent = false;
        onRemoved();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  // Usage example:
  const checkPreorderEnabled = () => {
    if (document.querySelector('[name="properties[PROMISE_DATE]"]')) {
      handlePreorderEnabled(document.querySelector('[name="properties[PROMISE_DATE]"]'));
    }

    observeElement(
      '[name="properties[PROMISE_DATE]"]',
      (element) => {
        handlePreorderEnabled(element);
      },
      () => {
        handlePreorderDisabled();
      }
    );
  };

  let variantsInfo = node.dataset.variants;

  try {
    if (variantsInfo) {
      variantsInfo = JSON.parse(variantsInfo);
    } else {
      variantsInfo = null;
    }
  } catch (e) {
    variantsInfo = null;
  }

  /**
   * Functions
   */

  const findCurrentVariant = ({ fallbackToColor = false } = {}) => {
    const { selectedTexture, selectedColor, selectedSize } = node.dataset;

    if (selectedTexture && selectedSize && selectedColor) {
      return variantsInfo.find(
        (v) =>
          v.texture === selectedTexture &&
          v.size === selectedSize &&
          v.color === selectedColor
      );
    }

    if (selectedColor && selectedSize) {
      const exact = variantsInfo.find(
        (v) => v.color === selectedColor && v.size === selectedSize
      );
      if (exact || !fallbackToColor) return exact;
    }

    if (selectedColor) {
      return variantsInfo.find((v) => v.color === selectedColor);
    }

    return variantsInfo[0];
  };

  const handleAddToCart = async (e) => {
    e.preventDefault();

    const preorderInformation = document.querySelector(
      '[name="properties[PROMISE_DATE]"]'
    );

    let variantInfo = null;

    const defaultProductVariantId = node.dataset.defaultProductVariantId;
    let variantIdToAdd = defaultProductVariantId;

    const currentVariant = findCurrentVariant();
    if (currentVariant) {
      variantIdToAdd = currentVariant.id;
      variantInfo = currentVariant;
    } else if (node.dataset.selectedTexture || node.dataset.selectedColor) {
      console.error('No variant found');
      return;
    }

    const itemToAdd = [
      {
        id: Number(variantIdToAdd),
        quantity: quantityInput.value,
        ...(preorderInformation && preorderInformation.value && {
          properties: {
            PROMISE_DATE: preorderInformation.value,
            Type: 'Preorder',
          },
        }),
      },
    ];
    await addToCart(itemToAdd);

    if (window.customer.isChattersCustomer) {
      const chattersPopupImage = chattersPopup.querySelector(
        '[data-chatters-popup-image]'
      );
      const chattersPopupTitle = chattersPopup.querySelector(
        '[data-chatters-popup-title]'
      );

      chattersPopupImage.src = variantInfo.image;
      chattersPopupTitle.innerHTML = variantInfo.title;

      const popup = document.getElementById('chatters-popup');
      popup.style.right = '20px';

      setTimeout(() => {
        popup.style.right = '-400px';
      }, 3000);
      setTimeout(() => {
        chattersPopupImage.src = '';
        chattersPopupTitle.innerHTML = '';
      }, 5000);
    } else {
      // Emit event to open cart
      document.dispatchEvent(new CustomEvent('cart:open'));
    }
  };

  const updateSelectedTexture = (e) => {
    node.dataset.selectedTexture = e.detail.texture;
    validateAvailability();
  };

  const updateSelectedColor = (e) => {
    node.dataset.selectedColor = e.detail.color;
    validateAvailability();
  };

  const updateSelectedSize = (e) => {
    node.dataset.selectedSize = e.detail.size;
    validateAvailability();
  };

  const updateSelectedVariant = (e) => {
    node.dataset.defaultProductVariantId = e.detail.variantId;
    node.dataset.selectedColor = e.detail.selectedColor;
    node.dataset.selectedSize = e.detail.selectedSize;

    validateAvailability({
      availability: e.detail.availability,
      simpleVariantSelect: true,
      price: e.detail.price,
      compareAtPrice: e.detail.compareAtPrice,
    });

    if (notifyBackInStockVariantId)
      notifyBackInStockVariantId.value = e.detail.variantId;

    resetNotifyWhenInStockForm();
  };

  const validateAvailability = (e) => {
    if (e?.simpleVariantSelect) {
      // node.dataset.selectedColor = '';
      // node.dataset.selectedSize = '';
    }

    const currentVariant = findCurrentVariant({ fallbackToColor: true });
    const { selectedTexture, selectedColor, selectedSize } = node.dataset;
    const hasMultipleOptions =
      (selectedTexture && selectedSize && selectedColor) ||
      (selectedColor && selectedSize);

    if (currentVariant && hasMultipleOptions) {
      if (notifyBackInStockVariantId)
        notifyBackInStockVariantId.value = currentVariant.id;
      resetNotifyWhenInStockForm();

      document.dispatchEvent(
        new CustomEvent('variant:changed', {
          detail: { variantId: currentVariant.id },
        })
      );
    }
    const price = currentVariant
      ? currentVariant.price
      : e?.price
        ? e.price
        : '';

    priceElement.innerHTML = price;
    priceElement.dataset.productPrice = currentVariant
      ? currentVariant.price_without_money
      : '';

    const compareAtPrice = currentVariant
      ? currentVariant.compare_at_price
      : e?.compareAtPrice
        ? e.compareAtPrice
        : '';

    if (compareAtPriceElement) {
      compareAtPriceElement.innerHTML = compareAtPrice;
      compareAtPriceElement.dataset.productCompareAtPrice = currentVariant
        ? currentVariant.compare_at_price_without_money
        : '';
      if (compareAtPrice && compareAtPrice.length > 0) {
        compareAtPriceElement.classList.remove('hidden');
      } else {
        compareAtPriceElement.classList.add('hidden');
      }
    }

    // update suggested retail price
    if (suggestedRetailPriceElement) {
      suggestedRetailPriceElement.innerHTML = currentVariant
        ? currentVariant.suggested_retail_price
        : '';
    }

    if (
      (currentVariant && currentVariant.available) ||
      e?.availability === 'true'
    ) {
      const originalPrice = priceElement.dataset.productPrice;

      const newPrice = Shopify.formatMoney(
        Number(originalPrice) * Number(quantityInput.value),
        moneyFormat
      );

      buttonAddToCart.innerHTML =
        quantityAndAddToCartWrapper.dataset.addToCartString + ' ' + newPrice;

      if (popupAddToCartButton) {
        popupAddToCartButton.innerHTML =
          quantityAndAddToCartWrapper.dataset.addToCartString + ' ' + newPrice;
      }

      outOfStockButtonWrapper.classList.add('hidden');
      quantityAndAddToCartWrapper.classList.remove('hidden');
      checkPreorderEnabled();
    } else {
      outOfStockButtonWrapper.classList.remove('hidden');
      quantityAndAddToCartWrapper.classList.add('hidden');
    }

    // update current variant id and URL
    node.dataset.currentVariantId = currentVariant.id;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', currentVariant.id);
    window.history.replaceState({}, '', url);
  };

  const handlePreorderEnabled = (e) => {
    const currentVariant = findCurrentVariant();

    if (e.value) {
      buttonAddToCart.innerHTML =
        quantityAndAddToCartWrapper.dataset.preorderString +
          ' ' +
          currentVariant.price || '';
    }

    if (popupAddToCartButton && e.value) {
      popupAddToCartButton.innerHTML =
        quantityAndAddToCartWrapper.dataset.preorderString +
          ' ' +
          currentVariant.price || '';
    }

    if (shippingTodayNode) {
      shippingTodayNode.classList.add('hidden');
    }

    if (preorderCallout && e.value) {
      try {
        const [dayValue, monthValue, yearValue] = e.value
          .split('-')
          .map(Number);
        const date = new Date(yearValue, monthValue - 1, dayValue);

        // Get the month and year using toLocaleDateString, but separately
        const month = date.toLocaleDateString('en-US', { month: 'long' });

        // Get the day number and add the suffix
        const dayNumber = date.getDate();
        const dayWithSuffix = getOrdinalSuffix(dayNumber);

        // Construct the formatted string
        const formattedDate = `${month} ${dayWithSuffix}`;

        const preorderCalloutText = preorderCallout.querySelector(
          '[data-preorder-callout-text]'
        );

        preorderCalloutText.innerHTML = preorderCalloutText.innerHTML.replace(
          '{{date}}',
          formattedDate
        );
      } catch (e) {
        console.error('Error parsing date', e);
      }

      preorderCallout.classList.remove('hidden');
    }
  };

  const handlePreorderDisabled = () => {
    const currentVariant = findCurrentVariant();

    buttonAddToCart.innerHTML =
      quantityAndAddToCartWrapper.dataset.addToCartString +
        ' ' +
        currentVariant.price || '';

    if (popupAddToCartButton) {
      popupAddToCartButton.innerHTML =
        quantityAndAddToCartWrapper.dataset.addToCartString +
          ' ' +
          currentVariant.price || '';
    }

    if (shippingTodayNode) {
      shippingTodayNode.classList.remove('hidden');
    }
    if (preorderCallout) {
      preorderCallout.classList.add('hidden');
    }
  };

  const updatePriceButtonAddToCart = () => {
    // update price in the add to cart button
    const productPrice = document.querySelector('#price');
    if (productPrice) {
      const price = productPrice.dataset.productPrice;
      const newPrice = Shopify.formatMoney(
        Number(price) * Number(quantityInput.value),
        moneyFormat
      );
      buttonAddToCart.innerHTML =
        quantityAndAddToCartWrapper.dataset.addToCartString + ' ' + newPrice;

      if (popupAddToCartButton) {
        popupAddToCartButton.innerHTML =
          quantityAndAddToCartWrapper.dataset.addToCartString + ' ' + newPrice;
      }
    }
  };

  const increaseQuantity = () => {
    quantityInput.value = Number(quantityInput.value) + 1;
    updatePriceButtonAddToCart();
  };
  const decreaseQuantity = () => {
    if (quantityInput.value > 1) {
      quantityInput.value = Number(quantityInput.value) - 1;
      updatePriceButtonAddToCart();
    }
  };

  const handleNotifyWhenInStock = async (e) => {
    e.preventDefault();
    const formData = new FormData(notifyWhenInStockForm);
    const data = {
      email: formData.get('email'),
      variant_id: formData.get('variant_id'),
    };

    if (!data.email || !data.variant_id) {
      console.error('Missing email or variant_id');
      return;
    }

    try {
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: data.email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${data.variant_id}`,
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-06-15',
        },
        body: JSON.stringify(payload),
      };
      const response = await fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=T5aHp6',
        requestOptions
      );

      if (!response.ok) {
        console.error('😟 Error:', response.status, response.statusText);
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      notifyWhenInStockSuccessMessage.classList.remove('hidden');
      notifyWhenInStockRegularMessage.classList.add('hidden');
      notifyWhenInStockForm.classList.add('hidden');
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const resetNotifyWhenInStockForm = () => {
    notifyWhenInStockRegularMessage.classList.remove('hidden');
    notifyWhenInStockSuccessMessage.classList.add('hidden');
    notifyWhenInStockForm.classList.remove('hidden');
  };

  /**
   * Init
   */
  const init = () => {
    checkPreorderEnabled();
    buttonAddToCart.addEventListener('click', handleAddToCart);

    quantityIncrease.addEventListener('click', increaseQuantity);
    quantityDecrease.addEventListener('click', decreaseQuantity);

    // NEW: Listen for texture changes (3-option products)
    document.addEventListener(
      'add-to-cart:selected-texture-change',
      updateSelectedTexture
    );

    document.addEventListener(
      'add-to-cart:selected-color-change',
      updateSelectedColor
    );

    document.addEventListener(
      'add-to-cart:selected-size-change',
      updateSelectedSize
    );

    document.addEventListener(
      'add-to-cart:selected-variant-change',
      updateSelectedVariant
    );

    if (notifyWhenInStockForm)
      notifyWhenInStockForm.addEventListener('submit', handleNotifyWhenInStock);
  };

  init();
};
